import { IPanelColumnList } from '../types';
import { getAnyNodeKey } from '../utils';
import AnyNode from '../node/AnyNode';
import React from 'react';
import { MenuCol, MenuColWrapper } from '../EntitySelectionPanelUI';
import { PrimaryButton } from '../../../Button';
import { usePanelStateContext } from '../context';
import { isNil } from 'lodash';
import EventDataRefresh from '../../../DataRefresh/EventDataRefresh';
import ThinDivider from '../../../ThinDivider';
import styled from 'styled-components';
import DictionaryView from '../../../QuickAccessDictionary/DictionaryView';

interface IProps {
  panel: IPanelColumnList;
}

const StyledPrimaryButton = styled(PrimaryButton)`
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

const StyledDictionaryView = styled.div`
  display: flex;
  padding: 4px 8px;
  column-gap: 8px;
`;

const ListPanel = ({ panel }: IProps) => {
  const { onCreateCustom, schemaId, refreshSearch } = usePanelStateContext();
  return (
    <MenuColWrapper>
      <MenuCol>
        {panel.items.map((node, i) => (
          <AnyNode
            indent={0}
            node={node}
            key={getAnyNodeKey(node, i)}
            onSelectNode={panel.onSelectNode}
            selectedNode={panel.selected}
          />
        ))}
      </MenuCol>
      {panel.shouldShowDataRefresh && (
        <>
          <ThinDivider layout="horizontal" size="full" />
          <StyledDictionaryView>
            <strong>Dictionary</strong>
            <DictionaryView />
          </StyledDictionaryView>
          <EventDataRefresh schemaId={schemaId} onRefreshEnd={refreshSearch} />
        </>
      )}

      {!isNil(onCreateCustom) && panel.index === 0 && (
        <StyledPrimaryButton
          onClick={onCreateCustom}
          trackContext="entity selection"
          trackAction="create custom"
        >
          Create Custom
        </StyledPrimaryButton>
      )}
    </MenuColWrapper>
  );
};
export default ListPanel;
